import styled from "@emotion/styled";

export const Container = styled.div`
  margin-block-end: 16px;

  svg {
    inline-size: 58px;
    block-size: 48px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-end: 0;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    margin-block-end: 0;

    svg {
      inline-size: 72px;
      block-size: 60px;
    }
  }
`;
